import axios from 'axios';

export type ApiError = {
  response: { status: number; codes: string[] };
};

type V1ErrorData = { errors: Array<{ code: string }> };
type V2ErrorData = { code: string };

const isV1ErrorData = (data: unknown): data is V1ErrorData => {
  if (!data || typeof data !== 'object') return false;
  const errors = (data as { errors?: unknown }).errors;
  if (!Array.isArray(errors)) return false;
  return errors.every(
    (entry) =>
      entry !== null &&
      typeof entry === 'object' &&
      typeof (entry as { code?: unknown }).code === 'string'
  );
};

const isV2ErrorData = (data: unknown): data is V2ErrorData =>
  !!data &&
  typeof data === 'object' &&
  typeof (data as { code?: unknown }).code === 'string';

export const getApiError = (error: unknown): ApiError | null => {
  if (!axios.isAxiosError(error)) return null;
  const response = error.response;
  if (!response) return null;

  const { data, status } = response;

  if (isV1ErrorData(data)) {
    return {
      response: {
        status,
        codes: data.errors.map((entry) => entry.code),
      },
    };
  }

  if (isV2ErrorData(data)) {
    return {
      response: {
        status,
        codes: [data.code],
      },
    };
  }

  return null;
};

export const isApiError = (error: unknown): error is ApiError =>
  getApiError(error) !== null;
